import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { NavLink, useLocation } from 'react-router-dom';
import AuthContext from 'providers/Auth/Auth.context';
import NotificationsContext from 'providers/Notifications/Notifications.context';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import ChatIcon from 'icons/Chat.icon';
import BellIcon from 'icons/Bell.icon';
import Counter from 'components/Counter';

import './MessagingAndNotification.styles.scss';
import './MessagingAndNotification.styles.responsive.scss';

type MessagingAndNotificationProps = {
  className?: string;
  hasMessagingLink?: boolean;
};

const MessagingAndNotification: React.FC<MessagingAndNotificationProps> = (
  props,
) => {
  const { className, hasMessagingLink = true } = props;

  const classes = classNames('messaging-and-notification', className);

  const { isLoggedIn } = useContext(AuthContext);
  const { currentUser, isRWCMember } = useContext(CurrentUserContext);
  const { notificationsCount, setIsDrawerOpen } =
    useContext(NotificationsContext);

  const { pathname } = useLocation();

  const isMessagingActive = useMemo(
    () => pathname.includes('dash/messaging'),
    [pathname],
  );

  if (!isLoggedIn) return null;

  return (
    <nav className={classes}>
      <ul>
        {hasMessagingLink && !isRWCMember && (
          <li className="messaging-li">
            <NavLink
              to="/dash/messaging"
              onClick={(ev) => {
                if (isMessagingActive) {
                  ev.preventDefault();
                }
              }}
            >
              <ChatIcon />
              <Counter
                count={currentUser?.totalUnreadMessages}
                isPositionAbsolute
              />
            </NavLink>
          </li>
        )}

        <li onClick={() => setIsDrawerOpen(true)}>
          <BellIcon />
          <Counter count={notificationsCount?.unread} isPositionAbsolute />
        </li>
      </ul>
    </nav>
  );
};

export default MessagingAndNotification;
